/**
 * @Name: 个人中心 Apis
 */

const host = 'eventsgo/media/'
const hostpublic = 'eventsgo/media/'
const hostcommon = 'eventsgo/common/'

// 获取隐私协议版本
export const GET_PRIVACY_VERSION = hostpublic + 'services/eventsgo/public/userConceal/privacy-version'
export const SELECT_AGREE_STATUS = hostpublic + 'services/eventsgo/public/userConceal/selectAgreeStatus'
// 同意隐私收集
export const SAVE_USER_CONCEAL = hostpublic + 'services/eventsgo/public/userConceal/saveUserConceal'
// 拒绝隐私收集
export const UPDETE_CONCEAL_STATUS = hostpublic + 'services/eventsgo/public/userConceal/updateConcealStatus'
// 删除单条导入记录
export const DELETE_IMPORT = hostcommon + 'services/eventsgo/common/myImportExportService/deleteImport'
// 删除单条导出记录
export const DELETE_EXPORT = hostcommon + 'services/eventsgo/common/myImportExportService/deleteExport'
// 根据当前登录人的用户ID查询个人信息
export const FIND_PERSONAL_USER = host + 'services/eventsgo/personcenter/personalUser/findPersonalUser'
// 保存或更新个人信息
export const SAVE_OR_UPTATE_PERSONAL_USER = host + 'services/eventsgo/personcenter/personalUser/saveOrUpdatePersonalUser'
// 分页查询查询常用联系人列表
export const FIND_CONTACT_PAGE_LIST = host + 'services/eventsgo/personcenter/contact/findContactPageList'
// 保存常用联系人
export const SAVE_CONTACT_INFO = host + 'services/eventsgo/personcenter/contact/saveContactInfo'
// 查询常用联系人详情
export const FIND_CONTACT_DETAIL_BY_ID = host + 'services/eventsgo/personcenter/contact/findContactDetailById'
// 删除常用联系人
export const DEL_CONTACT_DETAIL_BY_ID = host + 'services/eventsgo/personcenter/contact/delContactInfoById'
// 根据ID查询常用地址
export const DIND_FAVORITE_ADDRESS = host + 'services/eventsgo/personcenter/favoriteAddress/findFavoriteAddress'
// 常用地址分页查询接口
export const DIND_FAVORITE_ADDRESS_PAGED_LIST = host + 'services/eventsgo/personcenter/favoriteAddress/findFavoriteAddressPagedList'
// 新增或更新常用地址
export const SAVE_OR_UPTATE_FAVORITE_ADDRESS = host + 'services/eventsgo/personcenter/favoriteAddress/saveOrUpdateFavoriteAddress'
// 删除常用地址
export const DELETE_FAVORITE_ADDRESS = host + 'services/eventsgo/personcenter/favoriteAddress/deleteFavoriteAddress'
// 根据ID查询常用发票
export const GET_INVOICE_INFO = host + 'services/eventsgo/personcenter/invoice/getInvoiceInfo'
// 常用地址分页查询接口
export const GET_INVOICE_LIST = host + 'services/eventsgo/personcenter/invoice/getInvoiceList'
// 新增或更新常用地址
export const ADD_OR_UODATE_INVOICE = host + 'services/eventsgo/personcenter/invoice/addOrUpdateInvoice'
// 删除常用地址
export const DELETE_INVOICE = host + 'services/eventsgo/personcenter/invoice/deleteInvoice'
// 搜索联系人2
export const FIND_CONTACT2 = host + 'services/eventsgo/personcenter/contact/list'

/** ============ 我的导入导出 ================= */
// 我的导入
export const GET_MY_IMPORT_DATA = 'eventsgo/common/services/eventsgo/common/myImportExportService/listimport/page'
// 我的导出
export const GET_MY_EXPORT_DATA = 'eventsgo/common/services/eventsgo/common/myImportExportService/listexport/page'
